import { render, staticRenderFns } from "./FormLayout.vue?vue&type=template&id=5ad2b434"
import script from "./FormLayout.vue?vue&type=script&lang=ts"
export * from "./FormLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports